import { useEffect, useState } from "react";

// 마우스(hover)가 없는 기기인가 — `(hover: none)` 미디어 쿼리. 휴대폰·태블릿이 여기 해당한다.
// Chakra Tooltip 은 터치에서 hover 로는 안 열리고 focus 로만 열리기 때문에, 탭이 동작(이동·복사·토글)인 컨트롤 위의 툴팁은
// 탭 뒤 다른 곳을 탭할 때까지 남는다(2026-09-27 실측 — 상단바 등급 배지). 그런 곳은 이 값으로 툴팁을 끈다(`ActionTooltip`).
// jsdom 처럼 matchMedia 가 없으면 false(마우스 있음)로 본다.
const QUERY = "(hover: none)";

export default function useTouchOnly() {
  const read = () => {
    try { return typeof window !== "undefined" && typeof window.matchMedia === "function" ? window.matchMedia(QUERY).matches : false; } catch { return false; }
  };
  const [touchOnly, setTouchOnly] = useState(read);
  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return undefined;
    let mq;
    try { mq = window.matchMedia(QUERY); } catch { return undefined; }
    const on = () => setTouchOnly(mq.matches);
    on();
    if (mq.addEventListener) mq.addEventListener("change", on); else mq.addListener(on);
    return () => { if (mq.removeEventListener) mq.removeEventListener("change", on); else mq.removeListener(on); };
  }, []);
  return touchOnly;
}
